import React, { useMemo } from "react"
import ProductsBox from "../ProductsBox"
import useWebsiteProducts from "../../hooks/useWebsiteProducts"
import {
  productImage,
  productText,
  publicProductPath,
} from "../../services/websiteProducts"

export default function CmsProductsBridge({ lang = "en" }) {
  const { products: apiProducts, loading, error } = useWebsiteProducts()

  const products = useMemo(
    () =>
      apiProducts.map(product => ({
        title: productText(product, lang, "title"),
        name: productText(product, lang, "title"),
        subname: productText(product, lang, "subtitle"),
        description: productText(product, lang, "description"),
        path: publicProductPath(product, lang),
        cmsImageUrl: productImage(product),
      })),
    [apiProducts, lang],
  )

  if (loading && !products.length) {
    return (
      <div className="container" style={{ padding: "60px 0", textAlign: "center" }}>
        {lang === "ar" ? "جارٍ تحميل المنتجات..." : "Loading products..."}
      </div>
    )
  }

  if (error && !products.length) {
    return (
      <div className="container" style={{ padding: "60px 0", textAlign: "center" }}>
        {lang === "ar"
          ? "تعذر تحميل المنتجات حالياً."
          : "Products are temporarily unavailable."}
      </div>
    )
  }

  return <ProductsBox products={products} />
}
